<template>
  <ul class="mb-1 text-gray-300 space-y-0.5">
    <li
      v-for="(facet) in facetFields"
      :key="facet.key"
      class="font-medium leading-4"
    >
      <div class="flex items-center max-w-full md:items-star md:max-w-full">
        <input
          :id="facet.key"
          :name="facet.key"
          :checked="setSelectedFields(facet.key)"
          type="checkbox"
          class="w-4 h-4 mr-1 md:mr-2 transition duration-150 ease-in-out rounded form-checkbox"
          @change="toggleCheckBox(facet.key)"
        >
          <span class="flex items-center space-x-2 truncate cursor-pointer">
            <label
              :for="facet.key"
              class="text-xs md:text-sm font-medium leading-3 truncate"
            >
              {{ facet.key }}
            </label>
            <span class="inline-flex items-center px-1.5 rounded-full text-xxs font-bold bg-gray-200 text-gray-700">
              {{ facet.doc_count }}
            </span>
          </span>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    facetFields: {
      type: [Array, Object],
      required: true,
    },
    fieldName: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    selectedFields: {
      type: [Array, Object],
      required: false,
    },
  },
  data() {
    return {
      filters: {
        'name': this.fieldName,
        'values': [],
      },
    }
  },
  mounted() {
    this.addSelectedFieldsToFilters();
  },
  methods: {
    toggleCheckBox(value) {
      if (this.filters.values.includes(value)) {
        var index = this.filters.values.indexOf(value);
        this.filters.values.splice(index, 1);
      } else {
        this.filters.values.push(value);
      }
      this.$emit('set-filters', this.filters);
    },
    labelToUpper(str) {
      var i, frags = str.split('_');
      for (i=0; i<frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(' ');
    },
    setSelectedFields(field) {
      if (!this.selectedFields[this.fieldName]) {
        return false;
      }
      
      return this.selectedFields[this.fieldName].includes(field);
    },
    addSelectedFieldsToFilters() {
      if(!this.selectedFields[this.fieldName]){
        return;
      }
      this.filters.values=this.selectedFields[this.fieldName];
    }
  }
}
</script>
